const trainingData = [
    {
        id: "bs7858",
        title: "BS7858: Vetting and Screening",
        description: "The standard for best practice in the vetting of individuals employed in a security environment.",
        modules: [
            "Introduction to BS7858:2019",
            "Vetting Procedures & Documentation",
            "Financial Background Checks",
            "Employment History Verification",
            "Criminal Record Checks"
        ]
    },
    {
        id: "bs10800",
        title: "BS10800: Provision of Security Services",
        description: "The overarching standard for the management and delivery of security services.",
        modules: [
            "Service Delivery Framework",
            "Management Responsibilities",
            "Resource Management",
            "Operational Procedures",
            "Performance Monitoring"
        ]
    },
    {
        id: "bs99",
        title: "BS99: Security of Personnel",
        description: "Standards and practices for ensuring the safety and security of staff in high-risk environments.",
        modules: [
            "Risk Assessment for Personnel",
            "Protective Equipment Standards",
            "Emergency Response Protocols",
            "Conflict Resolution Training",
            "Reporting and Documentation"
        ]
    }
];

export default trainingData;
